export default __webpack_public_path__ + "static/img/panelArt_light.c5c6c081.svg";